import React from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import numeral from "numeral";

const ContactInfoWrapper = styled(Grid)`
  padding-top:20px;
  line-height:initial;
`;
const LineItem = styled(Grid)`
  && {
    margin-bottom:8px;
  }  
`;
const Emboldened = styled(Grid)`
  font-weight:bold;
`;
const Disclaimer = styled.div`
  padding-top:30px;
`;
const ContactInfo = ({ contact }) => (
  <ContactInfoWrapper container alignItems="center">
    <LineItem container item>
      <Emboldened item xs={4}>Email</Emboldened>
      <Grid>{contact.email}</Grid>
    </LineItem>
    <LineItem container item>
      <Emboldened item xs={4}>Phone Number</Emboldened>
      <Grid>{numeral(contact.phone).format("(NNN) NNN-NNNN")}</Grid>
    </LineItem>
    <LineItem container item>
      <Emboldened item xs={4}>Address</Emboldened>
      <Grid item>
        <div>{contact.address}</div>
        <div>{contact.address2}</div>
        <div>
          {contact.city}
          ,
          {" "}
          {contact.state}
          {" "}
          {contact.zip}
        </div>
      </Grid>
    </LineItem>
    <Disclaimer>
      To edit this user's contact information, please contact your LoanBoss Administrator.
    </Disclaimer>
  </ContactInfoWrapper>
);
export default ContactInfo;
